var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// @ts-nocheck
import { Button, CircularProgress, makeStyles, } from '@material-ui/core';
import { mergeClasses } from '@material-ui/styles';
import React, { useEffect, useState } from 'react';
const useStyles = makeStyles(() => ({
    root: {
        textTransform: 'none',
    },
    children: {
        textDecoration: 'underline',
    },
}));
const TimeButton = ({ time = 30, classes: newClasses = {}, onClick, children, }) => {
    const baseClasses = useStyles();
    const classes = mergeClasses({
        baseClasses,
        newClasses,
        Component: TimeButton,
    });
    const [remain, setRemain] = useState(time);
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        setTimeout(() => {
            setRemain((t) => {
                if (t === 0)
                    return t;
                return t - 1;
            });
        }, 1000);
    }, [remain]);
    const requestNewCode = (props) => __awaiter(void 0, void 0, void 0, function* () {
        setIsLoading(true);
        try {
            yield onClick(props);
        }
        catch (err) {
            console.error(err);
        }
        finally {
            setIsLoading(false);
            setRemain(time);
        }
    });
    return (React.createElement(Button, { variant: 'text', color: 'primary', className: classes.root, disabled: remain !== 0, onClick: requestNewCode, fullWidth: true }, isLoading ? (React.createElement(CircularProgress, { size: 20 })) : (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classes.children }, children),
        React.createElement("span", null, remain !== 0 ? `(${remain} sec)` : '')))));
};
export default TimeButton;
